import _ from 'underscore';

// helper functions
const makeKeyPath = (key) => {
    if(_.isArray(key)) return key;
    if(_.isString(key)) {
        return key.split('.');
    }
};

// get, set mixin
_.mixin({
    toLower: (str = '') => {
        return str.toLowerCase();
    },
    validate: (obj = {}) => _.reduce(_.values(obj), (a,b) => a && b, true),
    get: (object = {}, keyPath) => {
        if(_.isObject(object)) {
            const path = makeKeyPath(keyPath);
            let valueInObject = object;
            if(!_.isUndefined(path)) _.each(path, (value) => _.isUndefined(valueInObject) || (valueInObject = valueInObject[value]))
            return valueInObject;
        }
    },
    set: (object, keyPath, value) => {
        if(_.isUndefined(object)) return;
        const path = makeKeyPath(keyPath);
        let valueInObject = object;
        let parent = object;
        if(!_.isUndefined(path)) _.each(path, (value) => {
            if(!_.isUndefined(valueInObject)) {
                parent = valueInObject;
                valueInObject = valueInObject[value];
            }
            if(_.isUndefined(valueInObject)) {
                valueInObject = {};
                parent[value] = valueInObject;
            }
        });
        parent[_.last(path)] = value;
    }
});

// has mixin
_.mixin({
    has: (object, keyPath) => !_.isUndefined(_.get(object, keyPath))
});
